const removeCurrencySymbol = (price) => {
  if (price && price.length > 0) {
    return parseInt(price[0]) ? price : price.substring(1);
  }
  return price;
};

export default removeCurrencySymbol;
